// The colours people expect for each party (US: Democrats blue, Republicans red). Order matters: the first match wins.
const RULES = [
  [/liberal democrat|lib dem/i, "#F97316"],
  [/social democrat|\bspd\b|labou?r|socialist|\bndp\b/i, "#DC2626"],
  [/democrat|^d$/i, "#2563EB"],
  [/republican|^r$|\bgop\b/i, "#DC2626"],
  [/green/i, "#16A34A"],
  [/libertarian/i, "#EAB308"],
  [/scottish national|\bsnp\b/i, "#FACC15"],
  [/one nation/i, "#EA580C"],
  [/reform/i, "#0EA5E9"],
  [/\bnationals?\b/i, "#15803D"],
  [/conservative|tory|tories|liberal|coalition|likud|\bcdu\b|netanyahu/i, "#1D4ED8"],
  [/independent|^i$|non-?partisan|teal/i, "#94A3B8"],
];
const OTHER = ["#F59E0B", "#8B5CF6", "#14B8A6", "#EC4899", "#64748B", "#A16207"];

export const partyColour = (party, i = 0) => RULES.find(([re]) => re.test(party || ""))?.[1] || OTHER[i % OTHER.length];
